export default __webpack_public_path__ + "locales/ja-JP/ConnectDialog.json?hash=0d7b67339053b7580e91224486b4facd";